export default {
    achievement_locked: 'Locked item',
    avatars: 'Avatars',
    books: 'Books',
    buy_this_book: 'Buy this book',
    buy_this_pack: 'Buy this pack',
    buy_this_skin: 'Buy this skin',
    cost: 'cost:',
    favorites: 'Favorites',
    next: 'Next',
    of: ' of ',
    pack_of: 'Pack of',
    previous: 'Previous',
    return: 'Return',
    search: 'Search',
    skins: 'Skins',
    this_book: 'This book',
    this_pack: 'This pack',
    this_skin: 'This skin',
    you_have: 'You have',
}